import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { PelicanLogo } from '../components/PelicanLogo';
import { ArrowRight } from 'lucide-react';
import { CURRICULA } from '../constants/curricula';

export const Subjects = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 mb-4">
            <PelicanLogo className="h-10 w-10 text-primary" strokeWidth={1.5} />
          </div>
          <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight mb-4">Choose Your Curriculum</h1>
          <p className="text-base sm:text-lg text-foreground/75 max-w-2xl mx-auto leading-relaxed">
            Browse resources by qualification. Pick your curriculum to see the subjects available.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {CURRICULA.map((c) => (
            <Link
              key={c.name}
              to={`/curriculum/${encodeURIComponent(c.name)}`}
              data-testid={`subjects-curriculum-card-${c.name.toLowerCase()}`}
              className="group"
            >
              <div className={`relative h-full p-8 rounded-2xl border-2 ${c.light} hover:-translate-y-1 transition-all duration-300 hover:shadow-md overflow-hidden`}>
                <div className={`absolute -top-10 -right-10 w-32 h-32 rounded-full bg-gradient-to-br ${c.accent} opacity-20 blur-2xl group-hover:opacity-30 transition-opacity`} />
                <div className="relative">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-3xl font-semibold tracking-tight">{c.name}</h3>
                    <ArrowRight className="h-5 w-5 text-foreground/40 group-hover:text-primary group-hover:translate-x-1 transition-all" strokeWidth={1.5} />
                  </div>
                  <p className="text-sm text-foreground/75 leading-relaxed mb-4">{c.description}</p>
                  {c.levels && (
                    <div className="flex gap-2">
                      {c.levels.map((lvl) => (
                        <span key={lvl} className={`text-xs px-2 py-1 rounded font-mono ${c.badge}`}>{lvl}</span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};
